import { render, staticRenderFns } from "./Inoculation.vue?vue&type=template&id=9d69a5f4"
import script from "./Inoculation.vue?vue&type=script&lang=js"
export * from "./Inoculation.vue?vue&type=script&lang=js"
import style0 from "./Inoculation.vue?vue&type=style&index=0&id=9d69a5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports